import React from 'react';

import { StyledCodeInput } from './StyledComponents';
import { PaypalThemedProvider } from '@/styles';

interface MultiBoxInputProps {
  errorMessage?: React.ReactNode;
  onChange: (pin: string) => void;
  inputValue: string;
}

export const MultiBoxInput = React.forwardRef<
  HTMLInputElement[],
  MultiBoxInputProps
>(({ errorMessage, onChange, inputValue }, ref) => (
  <PaypalThemedProvider>
    <StyledCodeInput
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      errorText={errorMessage}
      name="ciBasic"
      numberOnly={true}
      onChange={onChange}
      ref={ref}
      type="tel"
      value={inputValue}
    />
  </PaypalThemedProvider>
));
